import {
  create,
  // component
  NButton,
  NPopover,
  NIcon,
  NRadio,
  NCard,
  NSpace,
  NRadioGroup,
  NRadioButton,
  NGrid,
  NGridItem,
  NMenu,
  NSwitch,
  NDataTable,
  NLayout,
  NLayoutSider,
  NBreadcrumb,
  NBreadcrumbItem,
  NDrawer,
  NDrawerContent,
  NConfigProvider,
  NInput,
  NSelect,
  NDatePicker,
  NTag,
  NCheckboxGroup,
  NCheckbox,
  NAffix,
  NPagination,
  NForm,
  NFormItem,
  NGi,
  NUpload,
  NUploadTrigger,
  NTabs,
  NTabPane,
  NModal,
  NTree,
  NTooltip,
  NMessageProvider,
  NFormItemGi,
  NInputGroup,
  NInputGroupLabel,
  NInputNumber,
  NDialog,
  NDialogProvider,
  NNotificationProvider,
  NH1,
  NH2,
  NP,
  NAnchor,
  NAnchorLink,
  NWatermark,
  NBackTop,
  NAlert,
  NImage,
  NImageGroup,
  NEllipsis,
  NSkeleton,
  NSpin,
  NDynamicTags,
  NAutoComplete,
  NEmpty,
  NCollapse,
  NCollapseItem,
  NSteps,
  NStep,
  NProgress
} from "naive-ui";

const naive = create({
  components: [
    NButton,
    NPopover,
    NIcon,
    NRadio,
    NCard,
    NSpace,
    NRadioGroup,
    NRadioButton,
    NDynamicTags,
    NAutoComplete,
    NGrid,
    NGridItem,
    NMenu,
    NBreadcrumb,
    NBreadcrumbItem,
    NDrawer,
    NDrawerContent,
    NConfigProvider,
    NInput,
    NSelect,
    NDatePicker,
    NTag,
    NSwitch,
    NCheckboxGroup,
    NCheckbox,
    NAffix,
    NPagination,
    NSwitch,
    NLayout,
    NLayoutSider,
    NDataTable,
    NForm,
    NFormItem,
    NGi,
    NUpload,
    NUploadTrigger,
    NTabs,
    NTabPane,
    NModal,
    NTree,
    NTooltip,
    NMessageProvider,
    NFormItemGi,
    NInputGroup,
    NInputGroupLabel,
    NInputNumber,
    NDialog,
    NDialogProvider,
    NNotificationProvider,
    NH1,
    NH2,
    NP,
    NAnchor,
    NAnchorLink,
    NWatermark,
    NBackTop,
    NAlert,
    NImage,
    NImageGroup,
    NEllipsis,
    NSkeleton,
    NSpin,
    NCollapse,
    NCollapseItem,
    NEmpty,
    NSteps,
    NStep,
    NProgress,
  ],
});

export { naive };
